module.exports = "/assets/1127493d7af4b0fcade6427ba766868e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/S2.png
// module id = 2927
// module chunks = 0